import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { snackbarError, snackbarSuccess } from 'actions/snackbarMessage';
import axiosClient from '@lib/utils/axiosClient';
import { makeResourceKeys } from 'requests/resources/makeResources/makeResourcesKeys';

import { TCustomWebStylesModelV2, TCreateCustomWebStylesModelV2 } from '../types';

const BASE_URL = 'v2/customWebStyles';

export const key = makeResourceKeys('custom-web-styles');

const createFn = (createData: TCreateCustomWebStylesModelV2) =>
  axiosClient.post<TCustomWebStylesModelV2>(`${BASE_URL}`, createData);

export const useCreateCustomWebStyles = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation((data: TCreateCustomWebStylesModelV2) => createFn(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(key.$all);
      dispatch(snackbarSuccess('Successfully saved'));
    },
    onError: () => {
      dispatch(snackbarError('Something went wrong'));
    },
  });
};
